import React, { useMemo } from 'react';
import { GridContainer, Typography } from '@vp/swan';
import { usePriceContext } from 'src/hooks/PriceContextHooks';
import { useProductContext } from 'src/hooks/ProductContextHooks';
import { text } from 'src/utils/localizationUtil';
import { ProductOptionSelectionDisplayGrid } from './ProductOptionSelectionDisplayGrid';

interface Props {
  isMobile: boolean;
}
export const SuggestedProductOption = ({ isMobile }: Props) => {
  const { price } = usePriceContext();
  const { completedProductInformation, productInformation } = useProductContext();

  const optionsWithRecommendations = useMemo<Array<string>>(() => {
    if (productInformation.recommendedProductData) {
      return Object.entries(productInformation.recommendedProductData.productOptions).reduce<Array<string>>(
        (previous, [key, value]): Array<string> => {
          if (
            completedProductInformation?.selectedOptions[key] !== value &&
            completedProductInformation?.selectedOptions[key] !== undefined
          ) {
            previous.push(key);
          }
          return previous;
        },
        []
      );
    }
    return [];
  }, [productInformation.recommendedProductData, completedProductInformation?.selectedOptions]);

  if (!productInformation.recommendedProductData || optionsWithRecommendations.length === 0) {
    return null;
  }

  return (
    <>
      <Typography marginBottom={'7'}>{text('product-option-suggestion.modal-body')}</Typography>
      <GridContainer>
        <ProductOptionSelectionDisplayGrid
          selectedOptions={completedProductInformation?.selectedOptions ?? productInformation.selectedOptions}
          recommendedOptions={productInformation.recommendedProductData.productOptions}
          optionsToDisplay={optionsWithRecommendations}
          isMobile={isMobile}
          oldPrice={price}
          newPrice={productInformation.recommendedProductData.price}
        />
      </GridContainer>
    </>
  );
};

SuggestedProductOption.dispplayName = 'SuggestedProductOption';
